import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Package, Megaphone, Percent, Image as ImageIcon, LayoutGrid, MessageCircle } from 'lucide-react';

const AdminDashboard: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 bg-gradient-to-b from-pink-50 via-rose-50 to-pink-100 dark:bg-dark-bg dark:from-dark-bg dark:via-dark-bg dark:to-dark-bg min-h-screen transition-colors duration-300" dir="rtl">
      <div className="mb-8 text-right">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-dark-text transition-colors duration-300">
          {'\u0644\u0648\u062d\u0629 \u062a\u062d\u0643\u0645 \u0627\u0644\u0645\u062f\u064a\u0631'}
        </h1>
        <p className="text-sm sm:text-base text-gray-600 dark:text-dark-textSecondary mt-2 transition-colors duration-300">
          {'\u0645\u0631\u062d\u0628\u0627\u064b \u0628\u0643 \u0641\u064a \u0644\u0648\u062d\u0629 \u0625\u062f\u0627\u0631\u0629 \u0645\u062a\u062c\u0631\u0643'}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-8">
        <div className="bg-white dark:bg-dark-surface rounded-lg shadow-sm border border-gray-200 dark:border-dark-border p-6 transition-colors duration-300">
          <h2 className="text-lg font-medium text-gray-900 dark:text-dark-text mb-4 text-right transition-colors duration-300">
            {'\u0625\u062c\u0631\u0627\u0621\u0627\u062a \u0633\u0631\u064a\u0639\u0629'}
          </h2>
          <div className="space-y-3">
            <Link
              to="/admin/products/new"
              className="flex items-center p-3 text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-hover rounded-lg transition-colors duration-300"
            >
              <Plus className="h-5 w-5 ml-3 text-primary-600 dark:text-primary-400" />
              {'\u0625\u0636\u0627\u0641\u0629 \u0645\u0646\u062a\u062c \u062c\u062f\u064a\u062f'}
            </Link>
            <Link
              to="/admin/products"
              className="flex items-center p-3 text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-hover rounded-lg transition-colors duration-300"
            >
              <Package className="h-5 w-5 ml-3 text-primary-600 dark:text-primary-400" />
              {'\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0645\u0646\u062a\u062c\u0627\u062a'}
            </Link>
            <Link
              to="/admin/promotional-banners"
              className="flex items-center p-3 text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-hover rounded-lg transition-colors duration-300"
            >
              <Megaphone className="h-5 w-5 ml-3 text-primary-600 dark:text-primary-400" />
              {'\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062a \u0627\u0644\u062a\u0631\u0648\u064a\u062c\u064a\u0629'}
            </Link>
            <Link
              to="/admin/discounts"
              className="flex items-center p-3 text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-hover rounded-lg transition-colors duration-300"
            >
              <Percent className="h-5 w-5 ml-3 text-primary-600 dark:text-primary-400" />
              {'\u0625\u0636\u0627\u0641\u0629 \u062e\u0635\u0645'}
            </Link>
            <Link
              to="/admin/promotional-pictures"
              className="flex items-center p-3 text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-hover rounded-lg transition-colors duration-300"
            >
              <ImageIcon className="h-5 w-5 ml-3 text-primary-600 dark:text-primary-400" />
              {'\u062a\u0639\u062f\u064a\u0644 \u0627\u0644\u0635\u0648\u0631 \u0627\u0644\u062a\u0631\u0648\u064a\u062c\u064a\u0629'}
            </Link>
            <Link
              to="/admin/categories"
              className="flex items-center p-3 text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-hover rounded-lg transition-colors duration-300"
            >
              <LayoutGrid className="h-5 w-5 ml-3 text-primary-600 dark:text-primary-400" />
              {'\u062a\u0639\u062f\u064a\u0644 \u0627\u0644\u0627\u0642\u0633\u0627\u0645'}
            </Link>
            <Link
              to="/admin/contact-info"
              className="flex items-center p-3 text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-hover rounded-lg transition-colors duration-300"
            >
              <MessageCircle className="h-5 w-5 ml-3 text-primary-600 dark:text-primary-400" />
              {'\u062a\u0639\u062f\u064a\u0644 \u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0648\u0627\u0635\u0644'}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
